import React from 'react';
import PropTypes from 'prop-types';

import './PersonContent.scss';

export default function PersonContent(props) {
  return (
    <section
      className="c-event-section c-event-section--without-padding c-person-content-section"
      style={{ backgroundColor: '#efefef' }}
    >
      <div className="container">
        <div className="row c-person-content-section__wrapper">
          {props.children}
        </div>
      </div>
    </section>
  );
}

PersonContent.propTypes = {
  children: PropTypes.node,
};
